export default __webpack_public_path__ + "static/media/tool-icon-trainer.a97be90c.svg";